/* eslint-disable @typescript-eslint/no-explicit-any */

import { QueryParams, StringParam } from 'use-query-params';
import { IPaginationQueryParams, getPaginationQueryParams } from '../common/constants/pagination';
import { OrderDirection } from '../common/enums/order-direction.enum';
import { IHOCQueryProps } from '../common/interfaces/IHOCQueryProps';
import CommonRequestTable from './CommonRequestsTable';

export interface CommonRequestTableQueryPrps extends IPaginationQueryParams {
  year?: string;
  month?: string;
}

export type CommonRequestTableBasicProps = IHOCQueryProps<CommonRequestTableQueryPrps>;

const DEFAULT_QUERY_PARAMS = getPaginationQueryParams({
  orderBy: 'request_count',
  orderDirection: OrderDirection.DESC,
});

const CommonRequestTableWithQueryParams = () => {
  const queryConfig = {
    ...DEFAULT_QUERY_PARAMS,
    year: StringParam,
    month: StringParam
  };

  return (
    <QueryParams config={queryConfig}>
      {(props: any) => {
        return <CommonRequestTable {...props} />;
      }}
    </QueryParams>
  );
};

export default CommonRequestTableWithQueryParams;
